import React, { useState } from "react";
import "./App.scss";
import { About, Footer, Header, Skills, Testimonial, Work } from "./container";
import { Navbar } from "./components";
import { motion, AnimatePresence } from "framer-motion";

const App = () => {
  const [overlay, setOverlay] = useState(false);
  const [emailInvalid, setEmailInvalid] = useState(false);

  const toggleFunction = () => {
    setOverlay(false);
    setEmailInvalid(false);
  };

  return (
    <div className="app">
      {overlay && (
        <AnimatePresence>
          <div className="backdrop">
            <motion.div
              className="modal"
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{ y: 1000 }}
              transition={{ duration: 0.3 }}
            >
              <p className="p-text">
                {emailInvalid
                  ? "Please use the correct format of email!"
                  : "Please do not leave only empty spaces in the form!"}
              </p>
              <button onClick={toggleFunction}>Close</button>
            </motion.div>
          </div>
        </AnimatePresence>
      )}
      <Navbar />
      <Header />
      <About />
      <Work />
      <Skills />
      {/* <Testimonial /> */}
      <Footer
        overlay={overlay}
        setOverlay={setOverlay}
        setEmailInvalid={setEmailInvalid}
      />
    </div>
  );
};

export default App;
